import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import RoundBox from '../../components/RoundBox/roundBox';
import Button from '../../components/Button';
import { __ } from '../../utilities';
import SectionSeparator from '../../components/SectionSeparator';
import { travelsSelector, passengersNumber } from './selectors';

import { setStep, errorAlert } from '../App/actions';

import { BackButton } from '../Passengers';

class Reservation extends Component {
  constructor(props) {
    super(props);
    this.updateSelectedSeats = this.updateSelectedSeats.bind(this);
    this.countOfselectedSeats = this.countOfselectedSeats.bind(this);
    this.titleBuilder = this.titleBuilder.bind(this);
    this.setSelectedTravel = this.setSelectedTravel.bind(this);
    this.skipReservations = this.skipReservations.bind(this);

    this.state = {
      selectedSeats: {},
      selectedTravel: null,
    };
  }

  componentDidMount() {
    this.props.travels.forEach(travel => {
      travel.rounds.forEach(round => {
        const selectedSeatsInBus = {};
        round.buses.forEach(bus => {
          if (bus.length !== 0)
            selectedSeatsInBus[bus.busId] = bus.selectedSeats;
        });
        this.updateSelectedSeats(selectedSeatsInBus, round.roundId);
      });
    });
  }

  setSelectedTravel(travelIndex) {
    this.setState({
      selectedTravel: travelIndex,
    });
  }

  skipReservations() {
    this.props.dispatch(
      setStep('summary', {
        for: 'reservations',
        info: {},
      }),
    );
  }

  updateSelectedSeats(selectedSeatsForBus, roundId) {
    const updatedSeats = this.state.selectedSeats;
    updatedSeats[roundId] = selectedSeatsForBus;
    this.setState({
      selectedSeats: updatedSeats,
    });
  }

  countOfselectedSeats() {
    let countNeeded = 0;
    let countActual = 0;
    this.props.travels.forEach(travel => {
      travel.rounds.forEach(round => {
        if (round.isSeating) countNeeded += this.props.numberOfSeatsForRound;
      });
    });
    this.props.travels.forEach(travel => {
      travel.rounds.forEach(round => {
        round.buses.forEach(bus => {
          countActual += this.state.selectedSeats[round.roundId][bus.busId]
            .length;
        });
      });
    });
    if (countActual !== countNeeded) {
      this.props.dispatch(
        errorAlert(__('Nebol zvolený dostatočný počet miest!')),
      );
    } else {
      this.props.dispatch(
        setStep('summary', {
          for: 'reservations',
          info: this.state.selectedSeats,
        }),
      );
    }
  }

  titleBuilder(index) {
    switch (index) {
      case 1:
        return __('Výber sedadiel pre prvú cestu');
      case 2:
        return __('Výber sedadiel pre druhú cestu');
      case 3:
        return __('Výber sedadiel pre tretiu cestu');
      case 4:
        return __('Výber sedadiel pre štvrtú cestu');
      case 5:
        return __('Výber sedadiel pre piatu cestu');
      default:
        return '';
    }
  }

  render() {
    if (this.props.travels.length === 0) return <div />;

    const roundBoxs = [];
    this.props.travels.forEach((travel, indexOfTravel) => {
      roundBoxs.push(
        <SectionSeparator content={this.titleBuilder(indexOfTravel + 1)} />,
      );
      travel.rounds.forEach(round => {
        roundBoxs.push(
          <RoundBox
            key={round.roundId}
            selectedTravel={this.state.selectedTravel}
            travelIndex={indexOfTravel}
            selectTravel={e => this.setSelectedTravel(e)}
            round={round}
            selectedSeats={this.state.selectedSeats}
            numberOfSeatsForRound={this.props.numberOfSeatsForRound}
            updateSelectedSeats={(a, b) =>
              this.updateSelectedSeats(a, b, indexOfTravel)
            }
          />,
        );
      });
    });
    return (
      <div>
        {roundBoxs}
        <SectionSeparator
          content={[
            <BackButton basic primary onClick={this.props.backStep}>
              {__('Späť')}
            </BackButton>,
            <Button primary onClick={() => this.countOfselectedSeats()}>
              {__('Pokračovať')}
            </Button>,
            <Button basic primary onClick={this.skipReservations}>
              {__('Pokračovať bez výberu miestenky')}
            </Button>,
          ]}
        />
      </div>
    );
  }
}
Reservation.propTypes = {
  backStep: PropTypes.func,
  numberOfSeatsForRound: PropTypes.number,
  travels: PropTypes.arrayOf(
    PropTypes.shape({
      rounds: PropTypes.arrayOf(
        PropTypes.shape({
          roundId: PropTypes.number,
          from: PropTypes.number,
          to: PropTypes.number,
          buses: PropTypes.arrayOf(
            PropTypes.shape({
              busId: PropTypes.number,
              selectedSeats: PropTypes.arrayOf(PropTypes.number),
            }),
          ),
        }),
      ),
    }),
  ),
};

Reservation.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

Reservation.defaultProps = {
  numberOfSeatsForRound: 0,
  travels: [],
  backStep: () => {},
};

const mapStateToProps = state => {
  return {
    travels: travelsSelector(state),
    numberOfSeatsForRound: passengersNumber(state),
  };
};

export default connect(mapStateToProps)(Reservation);



// WEBPACK FOOTER //
// ./src/containers/Reservation/index.js